import { loader as gqlLoader } from 'graphql.macro';

export const clientStateSchema = gqlLoader('./client-schema.graphql');
